'use client'

import { useBlockPresentation } from './BlockModeContext'
import { BLOCK_PRESENTATION } from './constants'

export function BlockSurface({ children, className = '', as: Tag = 'section' }) {
  const mode = useBlockPresentation()
  const isStandalone = mode === BLOCK_PRESENTATION.STANDALONE

  return (
    <Tag
      className={[
        'nb-block-surface',
        isStandalone ? 'nb-block-surface--standalone' : 'nb-block-surface--embedded',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      data-block-presentation={mode}
    >
      {children}
    </Tag>
  )
}
